(function ($) {
  var animation_gif = (function(){
    var elem;

    function init (){
      elem = $('.vrv-AnimationGif');
      var now = (new Date()).getTime();

      elem.each(function () {
        var $this = $(this);
        $this.attr('src', $this.attr('src') + '?' + now).css({
          visibility: "hidden"
          ,opacity : 0
        });
      });

      $(window).on('load scroll', check_on_screen);
    }

    function check_on_screen (){
      elem.each(function () {
        var $this = $(this),
            $win = $(window),
            $this_offset_top = $this.offset().top,
            $this_height = $this.height(),
            win_scroll_top = $win.scrollTop(),
            win_height = $win.height();

        if (win_scroll_top < $this_offset_top && win_scroll_top + win_height > $this_offset_top + $this_height) {
          $this.css('visibility', 'visible').animate({opacity: '1'}, 400);
        }
      });
    }

    return {
      init : init
    }
  })();

  animation_gif.init();

  // for Tablet
  var $contents = $('.brand-Wrapper');
  var baseSize = 960;
  var tabletSize = 768;
  var zoom = function(){
    var winWidth = $(window).width();
    if(tabletSize <= winWidth && winWidth <= baseSize){
      var scale = Math.floor($(window).width() / baseSize * 10000) / 10000;
      $contents.css({zoom: scale});
    }else{
      $contents.css({zoom: 1});
    }
  }
  // zoom resize image
  $(window).on('resize', function(){
    zoom();
  });
  // end for Tablet
})($brand);
